import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateCloudflareStreamThumbnailUrl(
  videoId: string,
  seconds: number,
) {
  return `https://customer-huthml5rjkd100i9.cloudflarestream.com/${videoId}/thumbnails/thumbnail.jpg?time=${seconds}s&width=1920&height=1080`;
}
